module.exports = __webpack_public_path__ + "../resources/img/ic_bar.79d9c691.svg";